export default "__VITE_ASSET__CwCPPW6q__"